"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerSubheader = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var DrawerContext_1 = require("./DrawerContext");
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var DrawerSubheaderRender = function (props, ref) {
    var children = props.children, _a = props.divider, divider = _a === void 0 ? true : _a, _b = props.hideContentOnCollapse, hideContentOnCollapse = _b === void 0 ? true : _b, otherDivProps = __rest(props, ["children", "divider", "hideContentOnCollapse"]);
    var _c = (0, DrawerContext_1.useDrawerContext)().open, drawerOpen = _c === void 0 ? true : _c;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", __assign({ ref: ref, "data-testid": 'blui-drawer-sub-header', style: { visibility: drawerOpen || !hideContentOnCollapse ? 'inherit' : 'hidden' } }, otherDivProps), children),
        divider && react_1.default.createElement(Divider_1.default, null)));
};
/**
 * [DrawerSubheader](https://brightlayer-ui-components.github.io/react/components/drawer-subheader) component
 *
 * The `<DrawerSubheader>` is an optional section that renders below the header and above the body of the `<Drawer>`. It can be used to support custom content (passed as children), such as filtering options or to display additional information.
 */
exports.DrawerSubheader = react_1.default.forwardRef(DrawerSubheaderRender);
exports.DrawerSubheader.displayName = 'DrawerSubheader';
exports.DrawerSubheader.propTypes = {
    divider: prop_types_1.default.bool,
    hideContentOnCollapse: prop_types_1.default.bool,
};
